import styled from 'styled-components'

import Background from '../Background'
import BedroomList from './BedroomList'
import UnitList from './UnitList'
import Address from './Address'
import Price from './Price'
import ButtonGroup from './ButtonGroup'

import List from '../List'

const Body = styled(Background).attrs({
  type: 'white',
})`
  z-index: 1;
  min-height: 250px;
  margin: ${props => props.theme.gutter * -2}px ${props => props.theme.gutter}px 0;
  width: calc(100% - ${props => props.theme.gutter * 2}px);
  padding: ${props => props.theme.gutter}px;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.gray200};

  &:hover {
    box-shadow: ${props => props.theme.colors.gray700} 0 0 10px -5px;
  }

  display: flex;
  flex-direction: column;

  ${BedroomList} {
    flex: 1;
  }

  ${Address}, ${Price}, ${ButtonGroup}, ${List} {
    transition: max-height 0.5s ease-in-out;
    max-height: ${props => (props.show ? 0 : '250px')};
    overflow: hidden;
  }

  ${UnitList} {
    transition: max-height 1s ease-in-out;
    max-height: ${props => (props.show ? '250px' : 0)};
    overflow: hidden;
  }
`

export default Body
